import { firebaseAuth } from '../config/constants';


export function logout() {
  return firebaseAuth().signOut();
}

export function login(email, pw) {
  return firebaseAuth().signInWithEmailAndPassword(email, pw);
}

export function resetPassword(email) {
  return firebaseAuth().sendPasswordResetEmail(email);
}

export function auth(email, pw) {
  return firebaseAuth().createUserWithEmailAndPassword(email, pw);
  // .then(saveUser);
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js